export default {
  en: {
    title: "Professional reviews",
    common: {
      loading: "Loading...",
      save: "Save",
      delete: "Delete",
      noData: "No data",
      login: "Login",
    },
    sections: {
      filters: "Filters",
      strainSelection: "Strain selection",
      tastingMetadata: "Tasting metadata",
      visual: "Visual",
      aroma: "Aroma",
      flavor: "Flavor",
      smokeQuality: "Smoke quality",
      effect: "Effect",
      scales: "Scales and recognition points",
      points: "Points - what to boost and what to preserve",
      final: "Final",
      savedReviews: "Saved reviews",
    },
    fields: {
      reviewName: "Review name",
      strain: "Strain",
      customStrainName: "Custom strain name",
      customStrainCode: "Custom strain code",
      strainSelectionRequired: "Strain selection",
      tastingDate: "Tasting date",
      authorNameOptional: "Author (optional)",
      consumptionMethod: "Consumption method",
      dosage: "Dosage / number of puffs",
      context: "Context",
      visualScore: "Visual score",
      budShape: "Bud shape",
      densityOnSqueeze: "Density on squeeze",
      trichomesCharacter: "Trichomes character",
      trichomeCoverage: "Trichome coverage",
      colorPalette: "Color palette",
      firstVisualImpression: "First visual impression",
      aromaIntensity: "Aroma intensity",
      aromaOpening: "Aroma opening",
      aromaProfile: "Aroma profile",
      flavorMatchesAroma: "Does flavor match aroma",
      flavorIntensity: "Flavor intensity",
      flavorDynamics: "Flavor dynamics",
      aftertaste: "Aftertaste",
      throatFeel: "Throat feel",
      burn: "Burn",
      ash: "Ash",
      tarOilyRing: "Tar / oily ring",
      losesFlavor: "Loses flavor during smoking",
      negativeSensations: "Negative sensations while smoking",
      effectType: "Effect type",
      effectStrength: "Effect strength",
      direction: "Direction",
      mentalEffects: "Mental effects",
      bodyEffects: "Body effects",
      functionalEffects: "Functional effects",
      duration: "Duration",
      timeOfUse: "Time of use",
      recognizability: "Recognizability (blind recognition)",
      whoIsItFor: "Who is it for?",
      associationPositioning: "Association/positioning",
      strengths: "Strengths",
      preserve: "Preserve",
      downsides: "Downsides/deviations",
      commercialPotential: "Commercial potential",
      wouldBuyAgain: "Would buy again?",
      summaryStrongest: "Short summary: What is strongest?",
      summaryImprove: "Short summary: What to improve next batch?",
      summaryScores: {
        visual: "Visual",
        aroma: "Aroma",
        flavor: "Flavor",
        effect: "Effect",
        uniqueness: "Uniqueness",
      },
      comment: "Comment",
    },
    placeholders: {
      selectStrain: "Select strain",
      otherText: "Other (text)",
      allStrains: "All strains",
      effectStrength: "Effect strength",
      commercialPotential: "Commercial potential",
      recognizability: "Recognizability",
    },
    actions: {
      applyFilters: "Apply filters",
      clearFilters: "Clear filters",
      downloadPublic: "Download (Public)",
      downloadInternal: "Download (Internal)",
      downloadExtended: "Download (Extended)",
      duplicate: "Duplicate",
      edit: "Edit",
    },
    table: {
      strain: "Strain",
      date: "Date",
      author: "Author",
      effectStrength: "Effect strength",
      commercialPotential: "Commercial potential",
      recognizability: "Recognizability",
    },
    messages: {
      missingFieldsTitle: "Missing required fields",
      loadFailed: "Failed to load reviews",
      saveFailed: "Failed to save review",
      saved: "Saved",
      downloadFailed: "Download failed",
      confirmDelete: "Delete review?",
    },
    options: {
      scale: {
        "1": "1",
        "2": "2",
        "3": "3",
        "4": "4",
        "5": "5",
      },
      consumptionMethod: {
        joint: "Joint",
        bong: "Bong",
        pipe: "Pipe",
        vaporizer: "Vaporizer",
        other: "Other",
      },
      dosage: {
        low: "Low",
        medium: "Medium",
        high: "High",
      },
      context: {
        alone: "Alone",
        withCompany: "With company",
        beforeSleep: "Before sleep",
        beforeWork: "Before work",
        onWeekends: "On weekends",
      },
      budShape: {
        spherical: "Spherical",
        conical: "Conical",
        arrow: "Spike / arrow",
        clumpy: "Clumpy",
        wild: "Uneven / wild",
        commercial: "Commercial (even, neat)",
      },
      densityOnSqueeze: {
        stone: "Stone",
        veryDense: "Very dense",
        medium: "Medium",
        airy: "Airy",
        fluffy: "Fluffy",
      },
      trichomesCharacter: {
        dusty: "Dusty (crumbly)",
        greasy: "Greasy (sticky)",
        glassy: "Glassy (shiny)",
        matte: "Matte",
        speckled: "Speckled",
        even: "Even",
      },
      trichomeCoverage: {
        low: "Low",
        medium: "Medium",
        high: "High",
      },
      colorPalette: {
        lightGreen: "Light green",
        darkGreen: "Dark green",
        purple: "Purple",
        almostBlack: "Almost black",
        silver: "Silver",
        orangePistils: "Orange pistils",
        redPistils: "Red pistils",
        yellowPistils: "Yellow pistils",
      },
      firstVisualImpression: {
        wow: "Wow",
        veryInteresting: "Very interesting",
        normal: "Normal",
        nothingSpecial: "Nothing special",
      },
      aromaIntensity: {
        weak: "Weak",
        medium: "Medium",
        strong: "Strong",
      },
      aromaOpening: {
        noChange: "No change",
        increasesWhenBroken: "Increases when broken",
        increasesWhenGrinded: "Increases when grinded",
      },
      aromaProfile: {
        diesel: "Diesel",
        skunk: "Skunk",
        rubber: "Rubber",
        glue: "Glue",
        candy: "Candy",
        fruity: "Fruity",
        creamy: "Creamy",
        vanilla: "Vanilla",
        mint: "Mint",
        eucalyptus: "Eucalyptus",
        citrus: "Citrus",
        pine: "Pine",
        berries: "Berries",
        grape: "Grape",
        mango: "Mango",
        lychee: "Lychee",
        guava: "Guava",
        passionFruit: "Passion fruit",
        earthy: "Earthy",
        woody: "Woody",
        spicy: "Spicy",
        chemical: "Chemical",
        metal: "Metal",
        fermentation: "Fermentation",
        other: "Other",
      },
      flavorMatchesAroma: {
        yes: "Yes",
        partially: "Partially",
        no: "No",
      },
      flavorIntensity: {
        weak: "Weak",
        medium: "Medium",
        strong: "Strong",
      },
      flavorDynamics: {
        staysToEnd: "Stays until the end",
        fadesMiddle: "Fades in the middle",
        onlyBeginning: "Only at the beginning",
      },
      aftertaste: {
        sweet: "Sweet",
        sour: "Sour",
        gassy: "Gassy",
        earthy: "Earthy",
        minty: "Minty",
        metallic: "Metallic",
        other: "Other",
      },
      throatFeel: {
        smooth: "Smooth",
        normal: "Normal",
        harsh: "Harsh",
        burns: "Burns",
      },
      burn: {
        excellent: "Excellent",
        normal: "Normal",
        bad: "Bad",
      },
      ash: {
        white: "White",
        gray: "Gray",
        dark: "Dark",
      },
      tarOilyRing: {
        none: "None",
        slight: "Slight",
        strong: "Strong",
      },
      losesFlavor: {
        yes: "Yes",
        no: "No",
      },
      negativeSensations: {
        dries: "Dries",
        stings: "Stings",
        cough: "Cough",
        hardToDraw: "Hard to draw",
        none: "None",
      },
      effectType: {
        indica: "Indica",
        sativa: "Sativa",
        hybrid: "Hybrid",
      },
      effectStrength: {
        weak: "Weak",
        medium: "Medium",
        strong: "Strong",
      },
      direction: {
        up: "Up",
        neutral: "Neutral",
        down: "Down",
        wavy: "Wavy",
        slowOnset: "Slow onset",
        sharpStart: "Sharp start",
      },
      mentalEffects: {
        clarityFocus: "Clarity/focus",
        improvesMood: "Improves mood",
        calmsThoughts: "Calms thoughts",
        speedsThoughts: "Speeds thoughts",
        fog: "Fog",
        creativity: "Creativity",
        talkative: "Talkative",
        social: "Social",
        withdrawn: "Withdrawn",
      },
      bodyEffects: {
        bodyRelaxation: "Body relaxation",
        heaviness: "Heaviness",
        eyePressure: "Eye pressure",
        softWarmth: "Soft warmth",
        numbness: "Numbness",
        tingling: "Tingling",
        bodyEnergy: "Body energy",
      },
      functionalEffects: {
        painRelief: "Pain relief",
        antiStress: "Anti-stress",
        antiAnxiety: "Anti-anxiety",
        appetiteIncrease: "Appetite increase",
        helpsSleep: "Helps sleep",
        suitableForWork: "Suitable for work",
        suitableForRest: "Suitable for rest",
      },
      duration: {
        short: "Short",
        medium: "Medium",
        long: "Long",
      },
      timeOfUse: {
        day: "Day",
        evening: "Evening",
        night: "Night",
      },
      recognizability: {
        yes: "Yes",
        ratherYes: "Rather yes",
        ratherNo: "Rather no",
        no: "No",
      },
      whoIsItFor: {
        beginners: "Beginners",
        experienced: "Experienced",
        medicalUsers: "Medical users",
        dayUse: "Day use",
        eveningSleep: "Evening/sleep",
        social: "Social",
        solo: "Solo",
      },
      associationPositioning: {
        commercialHit: "Commercial hit",
        boutique: "Boutique (niche)",
        exotic: "Exotic",
        connoisseurs: "For connoisseurs",
        rawPotential: "Has potential but raw",
      },
      strengths: {
        visual: "Visual",
        smell: "Smell",
        taste: "Taste",
        effect: "Effect",
        uniqueness: "Uniqueness",
        commercialPotential: "Commercial potential",
      },
      preserve: {
        genetics: "Genetics",
        terpenes: "Terpenes",
        structure: "Structure",
        effect: "Effect",
        overallFeeling: "Overall feeling",
      },
      downsides: {
        weakTaste: "Weak taste",
        effectFadesQuickly: "Effect fades quickly",
        heavyOnset: "Heavy onset",
        irritatesThroat: "Irritates throat",
        tooSharp: "Too sharp",
        unclearEffect: "Unclear effect",
        noClearCharacter: "No clear character",
        other: "Other",
      },
      commercialPotential: {
        low: "Low",
        medium: "Medium",
        high: "High",
      },
      wouldBuyAgain: {
        yesDefinitely: "Yes, definitely",
        maybe: "Maybe",
        no: "No",
      },
    },
  },
  es: {
    title: "Reseñas profesionales",
    common: {
      loading: "Cargando...",
      save: "Guardar",
      delete: "Eliminar",
      noData: "Sin datos",
      login: "Iniciar sesión",
    },
    sections: {
      filters: "Filtros",
      strainSelection: "Selección de variedad",
      tastingMetadata: "Datos de degustación",
      visual: "Visual",
      aroma: "Aroma",
      flavor: "Sabor",
      smokeQuality: "Calidad del humo",
      effect: "Efecto",
      scales: "Escalas y puntos de reconocimiento",
      points: "Puntos: qué potenciar y qué preservar",
      final: "Final",
      savedReviews: "Reseñas guardadas",
    },
    fields: {
      reviewName: "Nombre de la resena",
      strain: "Variedad",
      customStrainName: "Nombre de variedad personalizado",
      customStrainCode: "Código de variedad personalizado",
      strainSelectionRequired: "Selección de variedad",
      tastingDate: "Fecha de degustación",
      authorNameOptional: "Autor (opcional)",
      consumptionMethod: "Método de consumo",
      dosage: "Dosis / número de caladas",
      context: "Contexto",
      visualScore: "Puntuación visual",
      budShape: "Forma del cogollo",
      densityOnSqueeze: "Densidad al apretar",
      trichomesCharacter: "Característica de los tricomas",
      trichomeCoverage: "Cobertura de tricomas",
      colorPalette: "Paleta de colores",
      firstVisualImpression: "Primera impresión visual",
      aromaIntensity: "Intensidad del aroma",
      aromaOpening: "Apertura del aroma",
      aromaProfile: "Perfil del aroma",
      flavorMatchesAroma: "¿El sabor coincide con el aroma?",
      flavorIntensity: "Intensidad del sabor",
      flavorDynamics: "Dinámica del sabor",
      aftertaste: "Retrogusto",
      throatFeel: "Sensación en la garganta",
      burn: "Combustión",
      ash: "Ceniza",
      tarOilyRing: "Alquitrán / anillo aceitoso",
      losesFlavor: "Pierde sabor al fumar",
      negativeSensations: "Sensaciones negativas al fumar",
      effectType: "Tipo de efecto",
      effectStrength: "Intensidad del efecto",
      direction: "Dirección",
      mentalEffects: "Efectos mentales",
      bodyEffects: "Efectos corporales",
      functionalEffects: "Efectos funcionales",
      duration: "Duración",
      timeOfUse: "Momento de uso",
      recognizability: "Reconocibilidad (a ciegas)",
      whoIsItFor: "¿Para quién es?",
      associationPositioning: "Asociación/posicionamiento",
      strengths: "Fortalezas",
      preserve: "Preservar",
      downsides: "Desventajas/desviaciones",
      commercialPotential: "Potencial comercial",
      wouldBuyAgain: "¿Lo comprarías de nuevo?",
      summaryStrongest: "Resumen breve: ¿qué es lo más fuerte?",
      summaryImprove: "Resumen breve: ¿qué mejorar en el próximo lote?",
      summaryScores: {
        visual: "Visual",
        aroma: "Aroma",
        flavor: "Sabor",
        effect: "Efecto",
        uniqueness: "Unicidad",
      },
      comment: "Comentario",
    },
    placeholders: {
      selectStrain: "Seleccionar variedad",
      otherText: "Otro (texto)",
      allStrains: "Todas las variedades",
      effectStrength: "Intensidad del efecto",
      commercialPotential: "Potencial comercial",
      recognizability: "Reconocibilidad",
    },
    actions: {
      applyFilters: "Aplicar filtros",
      clearFilters: "Limpiar filtros",
      downloadPublic: "Descargar (pública)",
      downloadInternal: "Descargar (interna)",
      downloadExtended: "Descargar (extendida)",
      duplicate: "Duplicar",
      edit: "Editar",
    },
    table: {
      strain: "Variedad",
      date: "Fecha",
      author: "Autor",
      effectStrength: "Intensidad del efecto",
      commercialPotential: "Potencial comercial",
      recognizability: "Reconocibilidad",
    },
    messages: {
      missingFieldsTitle: "Faltan campos obligatorios",
      loadFailed: "No se pudieron cargar las reseñas",
      saveFailed: "No se pudo guardar la reseña",
      saved: "Guardado",
      downloadFailed: "La descarga falló",
      confirmDelete: "¿Eliminar la reseña?",
    },
    options: {
      scale: {
        "1": "1",
        "2": "2",
        "3": "3",
        "4": "4",
        "5": "5",
      },
      consumptionMethod: {
        joint: "Porro",
        bong: "Bong",
        pipe: "Pipa",
        vaporizer: "Vaporizador",
        other: "Otro",
      },
      dosage: {
        low: "Baja",
        medium: "Media",
        high: "Alta",
      },
      context: {
        alone: "Solo",
        withCompany: "Con compañía",
        beforeSleep: "Antes de dormir",
        beforeWork: "Antes de trabajar",
        onWeekends: "Los fines de semana",
      },
      budShape: {
        spherical: "Esférico",
        conical: "Cónico",
        arrow: "Pico / flecha",
        clumpy: "Aglomerado",
        wild: "Irregular / salvaje",
        commercial: "Comercial (uniforme, prolijo)",
      },
      densityOnSqueeze: {
        stone: "Piedra",
        veryDense: "Muy denso",
        medium: "Medio",
        airy: "Aireado",
        fluffy: "Esponjoso",
      },
      trichomesCharacter: {
        dusty: "Polvoriento (quebradizo)",
        greasy: "Grasoso (pegajoso)",
        glassy: "Vítreo (brillante)",
        matte: "Mate",
        speckled: "Moteado",
        even: "Uniforme",
      },
      trichomeCoverage: {
        low: "Baja",
        medium: "Media",
        high: "Alta",
      },
      colorPalette: {
        lightGreen: "Verde claro",
        darkGreen: "Verde oscuro",
        purple: "Púrpura",
        almostBlack: "Casi negro",
        silver: "Plateado",
        orangePistils: "Pistilos naranjas",
        redPistils: "Pistilos rojos",
        yellowPistils: "Pistilos amarillos",
      },
      firstVisualImpression: {
        wow: "¡Guau!",
        veryInteresting: "Muy interesante",
        normal: "Normal",
        nothingSpecial: "Nada especial",
      },
      aromaIntensity: {
        weak: "Débil",
        medium: "Media",
        strong: "Fuerte",
      },
      aromaOpening: {
        noChange: "Sin cambios",
        increasesWhenBroken: "Aumenta al romper",
        increasesWhenGrinded: "Aumenta al moler",
      },
      aromaProfile: {
        diesel: "Diésel",
        skunk: "Skunk",
        rubber: "Goma",
        glue: "Pegamento",
        candy: "Dulce",
        fruity: "Frutal",
        creamy: "Cremoso",
        vanilla: "Vainilla",
        mint: "Menta",
        eucalyptus: "Eucalipto",
        citrus: "Cítrico",
        pine: "Pino",
        berries: "Bayas",
        grape: "Uva",
        mango: "Mango",
        lychee: "Lichi",
        guava: "Guayaba",
        passionFruit: "Maracuyá",
        earthy: "Terroso",
        woody: "Amaderado",
        spicy: "Especiado",
        chemical: "Químico",
        metal: "Metálico",
        fermentation: "Fermentación",
        other: "Otro",
      },
      flavorMatchesAroma: {
        yes: "Sí",
        partially: "Parcialmente",
        no: "No",
      },
      flavorIntensity: {
        weak: "Débil",
        medium: "Media",
        strong: "Fuerte",
      },
      flavorDynamics: {
        staysToEnd: "Se mantiene hasta el final",
        fadesMiddle: "Se desvanece a la mitad",
        onlyBeginning: "Solo al principio",
      },
      aftertaste: {
        sweet: "Dulce",
        sour: "Ácido",
        gassy: "Gasoso",
        earthy: "Terroso",
        minty: "Mentolado",
        metallic: "Metálico",
        other: "Otro",
      },
      throatFeel: {
        smooth: "Suave",
        normal: "Normal",
        harsh: "Áspero",
        burns: "Quema",
      },
      burn: {
        excellent: "Excelente",
        normal: "Normal",
        bad: "Mala",
      },
      ash: {
        white: "Blanca",
        gray: "Gris",
        dark: "Oscura",
      },
      tarOilyRing: {
        none: "Ninguno",
        slight: "Leve",
        strong: "Fuerte",
      },
      losesFlavor: {
        yes: "Sí",
        no: "No",
      },
      negativeSensations: {
        dries: "Reseca",
        stings: "Pica",
        cough: "Tos",
        hardToDraw: "Difícil de tirar",
        none: "Ninguna",
      },
      effectType: {
        indica: "Índica",
        sativa: "Sativa",
        hybrid: "Híbrida",
      },
      effectStrength: {
        weak: "Débil",
        medium: "Media",
        strong: "Fuerte",
      },
      direction: {
        up: "Arriba",
        neutral: "Neutro",
        down: "Abajo",
        wavy: "Ondulado",
        slowOnset: "Inicio lento",
        sharpStart: "Inicio brusco",
      },
      mentalEffects: {
        clarityFocus: "Claridad/enfoque",
        improvesMood: "Mejora el ánimo",
        calmsThoughts: "Calma los pensamientos",
        speedsThoughts: "Acelera los pensamientos",
        fog: "Neblina",
        creativity: "Creatividad",
        talkative: "Conversador",
        social: "Sociable",
        withdrawn: "Retraído",
      },
      bodyEffects: {
        bodyRelaxation: "Relajación corporal",
        heaviness: "Pesadez",
        eyePressure: "Presión ocular",
        softWarmth: "Calor suave",
        numbness: "Entumecimiento",
        tingling: "Hormigueo",
        bodyEnergy: "Energía corporal",
      },
      functionalEffects: {
        painRelief: "Alivio del dolor",
        antiStress: "Antiestrés",
        antiAnxiety: "Anti-ansiedad",
        appetiteIncrease: "Aumento del apetito",
        helpsSleep: "Ayuda a dormir",
        suitableForWork: "Apto para trabajo",
        suitableForRest: "Apto para descanso",
      },
      duration: {
        short: "Corta",
        medium: "Media",
        long: "Larga",
      },
      timeOfUse: {
        day: "Día",
        evening: "Tarde",
        night: "Noche",
      },
      recognizability: {
        yes: "Sí",
        ratherYes: "Más bien sí",
        ratherNo: "Más bien no",
        no: "No",
      },
      whoIsItFor: {
        beginners: "Principiantes",
        experienced: "Experimentados",
        medicalUsers: "Usuarios medicinales",
        dayUse: "Uso diurno",
        eveningSleep: "Noche/sueño",
        social: "Social",
        solo: "Solo",
      },
      associationPositioning: {
        commercialHit: "Éxito comercial",
        boutique: "Boutique (nicho)",
        exotic: "Exótico",
        connoisseurs: "Para conocedores",
        rawPotential: "Tiene potencial pero es crudo",
      },
      strengths: {
        visual: "Visual",
        smell: "Olor",
        taste: "Sabor",
        effect: "Efecto",
        uniqueness: "Unicidad",
        commercialPotential: "Potencial comercial",
      },
      preserve: {
        genetics: "Genética",
        terpenes: "Terpenos",
        structure: "Estructura",
        effect: "Efecto",
        overallFeeling: "Sensación general",
      },
      downsides: {
        weakTaste: "Sabor débil",
        effectFadesQuickly: "El efecto se desvanece rápido",
        heavyOnset: "Inicio pesado",
        irritatesThroat: "Irrita la garganta",
        tooSharp: "Demasiado áspero",
        unclearEffect: "Efecto poco claro",
        noClearCharacter: "Sin carácter claro",
        other: "Otro",
      },
      commercialPotential: {
        low: "Bajo",
        medium: "Medio",
        high: "Alto",
      },
      wouldBuyAgain: {
        yesDefinitely: "Sí, definitivamente",
        maybe: "Quizá",
        no: "No",
      },
    },
  },
  ru: {
    title: "Профессиональные отзывы",
    common: {
      loading: "Загрузка...",
      save: "Сохранить",
      delete: "Удалить",
      noData: "Нет данных",
      login: "Войти",
    },
    sections: {
      filters: "Фильтры",
      strainSelection: "Выбор сорта",
      tastingMetadata: "Данные дегустации",
      visual: "Визуал",
      aroma: "Аромат",
      flavor: "Вкус",
      smokeQuality: "Качество дыма",
      effect: "Эффект",
      scales: "Шкалы и узнаваемость",
      points: "Акценты — что усилить и что сохранить",
      final: "Итог",
      savedReviews: "Сохраненные отзывы",
    },
    fields: {
      reviewName: "Название отзыва",
      strain: "Сорт",
      customStrainName: "Собственное название сорта",
      customStrainCode: "Собственный код сорта",
      strainSelectionRequired: "Выбор сорта",
      tastingDate: "Дата дегустации",
      authorNameOptional: "Автор (необязательно)",
      consumptionMethod: "Способ употребления",
      dosage: "Дозировка / количество затяжек",
      context: "Контекст",
      visualScore: "Оценка визуала",
      budShape: "Форма соцветий",
      densityOnSqueeze: "Плотность при сжатии",
      trichomesCharacter: "Характер трихом",
      trichomeCoverage: "Покрытие трихомами",
      colorPalette: "Цветовая палитра",
      firstVisualImpression: "Первое визуальное впечатление",
      aromaIntensity: "Интенсивность аромата",
      aromaOpening: "Раскрытие аромата",
      aromaProfile: "Профиль аромата",
      flavorMatchesAroma: "Совпадает ли вкус с ароматом",
      flavorIntensity: "Интенсивность вкуса",
      flavorDynamics: "Динамика вкуса",
      aftertaste: "Послевкусие",
      throatFeel: "Ощущение в горле",
      burn: "Горение",
      ash: "Пепел",
      tarOilyRing: "Смола / масляное кольцо",
      losesFlavor: "Теряет вкус при курении",
      negativeSensations: "Негативные ощущения при курении",
      effectType: "Тип эффекта",
      effectStrength: "Сила эффекта",
      direction: "Направление",
      mentalEffects: "Ментальные эффекты",
      bodyEffects: "Телесные эффекты",
      functionalEffects: "Функциональные эффекты",
      duration: "Длительность",
      timeOfUse: "Время употребления",
      recognizability: "Узнаваемость (вслепую)",
      whoIsItFor: "Для кого?",
      associationPositioning: "Ассоциация/позиционирование",
      strengths: "Сильные стороны",
      preserve: "Сохранить",
      downsides: "Недостатки/отклонения",
      commercialPotential: "Коммерческий потенциал",
      wouldBuyAgain: "Купили бы снова?",
      summaryStrongest: "Краткое резюме: что самое сильное?",
      summaryImprove: "Краткое резюме: что улучшить в следующей партии?",
      summaryScores: {
        visual: "Визуал",
        aroma: "Аромат",
        flavor: "Вкус",
        effect: "Эффект",
        uniqueness: "Уникальность",
      },
      comment: "Комментарий",
    },
    placeholders: {
      selectStrain: "Выберите сорт",
      otherText: "Другое (текст)",
      allStrains: "Все сорта",
      effectStrength: "Сила эффекта",
      commercialPotential: "Коммерческий потенциал",
      recognizability: "Узнаваемость",
    },
    actions: {
      applyFilters: "Применить фильтры",
      clearFilters: "Сбросить фильтры",
      downloadPublic: "Скачать (публичный)",
      downloadInternal: "Скачать (внутренний)",
      downloadExtended: "Скачать (расширенный)",
      duplicate: "Дублировать",
      edit: "Редактировать",
    },
    table: {
      strain: "Сорт",
      date: "Дата",
      author: "Автор",
      effectStrength: "Сила эффекта",
      commercialPotential: "Коммерческий потенциал",
      recognizability: "Узнаваемость",
    },
    messages: {
      missingFieldsTitle: "Отсутствуют обязательные поля",
      loadFailed: "Не удалось загрузить отзывы",
      saveFailed: "Не удалось сохранить отзыв",
      saved: "Сохранено",
      downloadFailed: "Не удалось скачать",
      confirmDelete: "Удалить отзыв?",
    },
    options: {
      scale: {
        "1": "1",
        "2": "2",
        "3": "3",
        "4": "4",
        "5": "5",
      },
      consumptionMethod: {
        joint: "Джойнт",
        bong: "Бонг",
        pipe: "Трубка",
        vaporizer: "Вапорайзер",
        other: "Другое",
      },
      dosage: {
        low: "Низкая",
        medium: "Средняя",
        high: "Высокая",
      },
      context: {
        alone: "В одиночку",
        withCompany: "В компании",
        beforeSleep: "Перед сном",
        beforeWork: "Перед работой",
        onWeekends: "На выходных",
      },
      budShape: {
        spherical: "Шаровидная",
        conical: "Коническая",
        arrow: "Шип / стрелка",
        clumpy: "Комковатая",
        wild: "Неровная / дикая",
        commercial: "Коммерческая (ровная, аккуратная)",
      },
      densityOnSqueeze: {
        stone: "Камень",
        veryDense: "Очень плотная",
        medium: "Средняя",
        airy: "Воздушная",
        fluffy: "Пышная",
      },
      trichomesCharacter: {
        dusty: "Пылевые (крошатся)",
        greasy: "Жирные (липкие)",
        glassy: "Стеклянные (блестящие)",
        matte: "Матовые",
        speckled: "Пятнистые",
        even: "Равномерные",
      },
      trichomeCoverage: {
        low: "Низкое",
        medium: "Среднее",
        high: "Высокое",
      },
      colorPalette: {
        lightGreen: "Светло-зеленый",
        darkGreen: "Темно-зеленый",
        purple: "Фиолетовый",
        almostBlack: "Почти черный",
        silver: "Серебристый",
        orangePistils: "Оранжевые пестики",
        redPistils: "Красные пестики",
        yellowPistils: "Желтые пестики",
      },
      firstVisualImpression: {
        wow: "Вау",
        veryInteresting: "Очень интересно",
        normal: "Нормально",
        nothingSpecial: "Ничего особенного",
      },
      aromaIntensity: {
        weak: "Слабый",
        medium: "Средний",
        strong: "Сильный",
      },
      aromaOpening: {
        noChange: "Без изменений",
        increasesWhenBroken: "Усиливается при разломе",
        increasesWhenGrinded: "Усиливается при помоле",
      },
      aromaProfile: {
        diesel: "Дизель",
        skunk: "Скунс",
        rubber: "Резина",
        glue: "Клей",
        candy: "Конфеты",
        fruity: "Фруктовый",
        creamy: "Сливочный",
        vanilla: "Ваниль",
        mint: "Мята",
        eucalyptus: "Эвкалипт",
        citrus: "Цитрус",
        pine: "Сосна",
        berries: "Ягоды",
        grape: "Виноград",
        mango: "Манго",
        lychee: "Личи",
        guava: "Гуава",
        passionFruit: "Маракуйя",
        earthy: "Землистый",
        woody: "Древесный",
        spicy: "Пряный",
        chemical: "Химический",
        metal: "Металлический",
        fermentation: "Ферментация",
        other: "Другое",
      },
      flavorMatchesAroma: {
        yes: "Да",
        partially: "Частично",
        no: "Нет",
      },
      flavorIntensity: {
        weak: "Слабая",
        medium: "Средняя",
        strong: "Сильная",
      },
      flavorDynamics: {
        staysToEnd: "Держится до конца",
        fadesMiddle: "Угасает в середине",
        onlyBeginning: "Только в начале",
      },
      aftertaste: {
        sweet: "Сладкое",
        sour: "Кислое",
        gassy: "Газовое",
        earthy: "Землистое",
        minty: "Мятное",
        metallic: "Металлическое",
        other: "Другое",
      },
      throatFeel: {
        smooth: "Мягко",
        normal: "Обычно",
        harsh: "Жёстко",
        burns: "Жжёт",
      },
      burn: {
        excellent: "Отлично",
        normal: "Нормально",
        bad: "Плохо",
      },
      ash: {
        white: "Белый",
        gray: "Серый",
        dark: "Темный",
      },
      tarOilyRing: {
        none: "Нет",
        slight: "Слабое",
        strong: "Сильное",
      },
      losesFlavor: {
        yes: "Да",
        no: "Нет",
      },
      negativeSensations: {
        dries: "Сушит",
        stings: "Щиплет",
        cough: "Кашель",
        hardToDraw: "Тяжело тянуть",
        none: "Нет",
      },
      effectType: {
        indica: "Индика",
        sativa: "Сатива",
        hybrid: "Гибрид",
      },
      effectStrength: {
        weak: "Слабый",
        medium: "Средний",
        strong: "Сильный",
      },
      direction: {
        up: "Вверх",
        neutral: "Нейтрально",
        down: "Вниз",
        wavy: "Волнами",
        slowOnset: "Медленное начало",
        sharpStart: "Резкий старт",
      },
      mentalEffects: {
        clarityFocus: "Ясность/фокус",
        improvesMood: "Улучшает настроение",
        calmsThoughts: "Успокаивает мысли",
        speedsThoughts: "Ускоряет мысли",
        fog: "Туман",
        creativity: "Творчество",
        talkative: "Разговорчивость",
        social: "Социальность",
        withdrawn: "Закрытость",
      },
      bodyEffects: {
        bodyRelaxation: "Расслабление тела",
        heaviness: "Тяжесть",
        eyePressure: "Давление в глазах",
        softWarmth: "Мягкое тепло",
        numbness: "Онемение",
        tingling: "Покалывание",
        bodyEnergy: "Энергия тела",
      },
      functionalEffects: {
        painRelief: "Обезболивание",
        antiStress: "Антистресс",
        antiAnxiety: "Против тревоги",
        appetiteIncrease: "Повышение аппетита",
        helpsSleep: "Помогает уснуть",
        suitableForWork: "Подходит для работы",
        suitableForRest: "Подходит для отдыха",
      },
      duration: {
        short: "Короткая",
        medium: "Средняя",
        long: "Долгая",
      },
      timeOfUse: {
        day: "День",
        evening: "Вечер",
        night: "Ночь",
      },
      recognizability: {
        yes: "Да",
        ratherYes: "Скорее да",
        ratherNo: "Скорее нет",
        no: "Нет",
      },
      whoIsItFor: {
        beginners: "Новички",
        experienced: "Опытные",
        medicalUsers: "Медицинские пользователи",
        dayUse: "Дневное использование",
        eveningSleep: "Вечер/сон",
        social: "Социальное",
        solo: "В одиночку",
      },
      associationPositioning: {
        commercialHit: "Коммерческий хит",
        boutique: "Бутик (нишевый)",
        exotic: "Экзотика",
        connoisseurs: "Для знатоков",
        rawPotential: "Есть потенциал, но сыровато",
      },
      strengths: {
        visual: "Визуал",
        smell: "Запах",
        taste: "Вкус",
        effect: "Эффект",
        uniqueness: "Уникальность",
        commercialPotential: "Коммерческий потенциал",
      },
      preserve: {
        genetics: "Генетика",
        terpenes: "Терпены",
        structure: "Структура",
        effect: "Эффект",
        overallFeeling: "Общее ощущение",
      },
      downsides: {
        weakTaste: "Слабый вкус",
        effectFadesQuickly: "Эффект быстро проходит",
        heavyOnset: "Тяжелое начало",
        irritatesThroat: "Раздражает горло",
        tooSharp: "Слишком резкий",
        unclearEffect: "Непонятный эффект",
        noClearCharacter: "Нет четкого характера",
        other: "Другое",
      },
      commercialPotential: {
        low: "Низкий",
        medium: "Средний",
        high: "Высокий",
      },
      wouldBuyAgain: {
        yesDefinitely: "Да, точно",
        maybe: "Возможно",
        no: "Нет",
      },
    },
  },
  he: {
    title: "ביקורות מקצועיות",
    common: {
      loading: "טוען...",
      save: "שמור",
      delete: "מחק",
      noData: "אין נתונים",
      login: "התחבר",
    },
    sections: {
      filters: "סינונים",
      strainSelection: "בחירת זן",
      tastingMetadata: "פרטי טעימה",
      visual: "חזות",
      aroma: "ארומה",
      flavor: "טעם",
      smokeQuality: "איכות העשן",
      effect: "השפעה",
      scales: "מדדים ונקודות זיהוי",
      points: "נקודות — מה לחזק ומה לשמר",
      final: "סיכום",
      savedReviews: "ביקורות שמורות",
    },
    fields: {
      reviewName: "שם הביקורת",
      strain: "זן",
      customStrainName: "שם זן מותאם",
      customStrainCode: "קוד זן מותאם",
      strainSelectionRequired: "בחירת זן",
      tastingDate: "תאריך טעימה",
      authorNameOptional: "מחבר (אופציונלי)",
      consumptionMethod: "שיטת צריכה",
      dosage: "מינון / מספר שאיפות",
      context: "הקשר",
      visualScore: "ציון חזותי",
      budShape: "צורת פרחים",
      densityOnSqueeze: "צפיפות בלחיצה",
      trichomesCharacter: "אופי הטריכומות",
      trichomeCoverage: "כיסוי טריכומות",
      colorPalette: "פלטת צבעים",
      firstVisualImpression: "רושם חזותי ראשון",
      aromaIntensity: "עוצמת הארומה",
      aromaOpening: "פתיחת ארומה",
      aromaProfile: "פרופיל ארומה",
      flavorMatchesAroma: "האם הטעם תואם את הארומה",
      flavorIntensity: "עוצמת הטעם",
      flavorDynamics: "דינמיקת הטעם",
      aftertaste: "טעם לוואי",
      throatFeel: "תחושה בגרון",
      burn: "בעירה",
      ash: "אפר",
      tarOilyRing: "זפת / טבעת שמנונית",
      losesFlavor: "מאבד טעם במהלך העישון",
      negativeSensations: "תחושות שליליות במהלך העישון",
      effectType: "סוג ההשפעה",
      effectStrength: "עוצמת ההשפעה",
      direction: "כיוון",
      mentalEffects: "השפעות מנטליות",
      bodyEffects: "השפעות גופניות",
      functionalEffects: "השפעות תפקודיות",
      duration: "משך",
      timeOfUse: "זמן שימוש",
      recognizability: "זיהוי (בעיוורון)",
      whoIsItFor: "למי זה מתאים?",
      associationPositioning: "אסוציאציה/מיצוב",
      strengths: "חוזקות",
      preserve: "לשמר",
      downsides: "חסרונות/סטיות",
      commercialPotential: "פוטנציאל מסחרי",
      wouldBuyAgain: "האם היית קונה שוב?",
      summaryStrongest: "תקציר קצר: מה הכי חזק?",
      summaryImprove: "תקציר קצר: מה לשפר במנה הבאה?",
      summaryScores: {
        visual: "חזות",
        aroma: "ארומה",
        flavor: "טעם",
        effect: "השפעה",
        uniqueness: "ייחודיות",
      },
      comment: "הערה",
    },
    placeholders: {
      selectStrain: "בחר זן",
      otherText: "אחר (טקסט)",
      allStrains: "כל הזנים",
      effectStrength: "עוצמת ההשפעה",
      commercialPotential: "פוטנציאל מסחרי",
      recognizability: "זיהוי",
    },
    actions: {
      applyFilters: "החל סינונים",
      clearFilters: "נקה סינונים",
      downloadPublic: "הורדה (פומבי)",
      downloadInternal: "הורדה (פנימי)",
      downloadExtended: "הורדה (מורחב)",
      duplicate: "שכפול",
      edit: "עריכה",
    },
    table: {
      strain: "זן",
      date: "תאריך",
      author: "מחבר",
      effectStrength: "עוצמת ההשפעה",
      commercialPotential: "פוטנציאל מסחרי",
      recognizability: "זיהוי",
    },
    messages: {
      missingFieldsTitle: "חסרים שדות חובה",
      loadFailed: "טעינת הביקורות נכשלה",
      saveFailed: "שמירת הביקורת נכשלה",
      saved: "נשמר",
      downloadFailed: "ההורדה נכשלה",
      confirmDelete: "למחוק את הביקורת?",
    },
    options: {
      scale: {
        "1": "1",
        "2": "2",
        "3": "3",
        "4": "4",
        "5": "5",
      },
      consumptionMethod: {
        joint: "ג'וינט",
        bong: "בונג",
        pipe: "מקטרת",
        vaporizer: "מאייד",
        other: "אחר",
      },
      dosage: {
        low: "נמוך",
        medium: "בינוני",
        high: "גבוה",
      },
      context: {
        alone: "לבד",
        withCompany: "עם חברה",
        beforeSleep: "לפני שינה",
        beforeWork: "לפני עבודה",
        onWeekends: "בסופי שבוע",
      },
      budShape: {
        spherical: "כדורי",
        conical: "חרוטי",
        arrow: "שפיץ / חץ",
        clumpy: "גושי",
        wild: "לא אחיד / פראי",
        commercial: "מסחרי (אחיד, מסודר)",
      },
      densityOnSqueeze: {
        stone: "אבן",
        veryDense: "צפוף מאוד",
        medium: "בינוני",
        airy: "אוורירי",
        fluffy: "רך",
      },
      trichomesCharacter: {
        dusty: "אבקתי (מתפורר)",
        greasy: "שומני (דביק)",
        glassy: "זגוגי (מבריק)",
        matte: "מט",
        speckled: "מנוקד",
        even: "אחיד",
      },
      trichomeCoverage: {
        low: "נמוך",
        medium: "בינוני",
        high: "גבוה",
      },
      colorPalette: {
        lightGreen: "ירוק בהיר",
        darkGreen: "ירוק כהה",
        purple: "סגול",
        almostBlack: "כמעט שחור",
        silver: "כסוף",
        orangePistils: "אבקנים כתומים",
        redPistils: "אבקנים אדומים",
        yellowPistils: "אבקנים צהובים",
      },
      firstVisualImpression: {
        wow: "וואו",
        veryInteresting: "מעניין מאוד",
        normal: "רגיל",
        nothingSpecial: "שום דבר מיוחד",
      },
      aromaIntensity: {
        weak: "חלש",
        medium: "בינוני",
        strong: "חזק",
      },
      aromaOpening: {
        noChange: "ללא שינוי",
        increasesWhenBroken: "מתגבר בעת שבירה",
        increasesWhenGrinded: "מתגבר בעת טחינה",
      },
      aromaProfile: {
        diesel: "דיזל",
        skunk: "סקאנק",
        rubber: "גומי",
        glue: "דבק",
        candy: "מתוק",
        fruity: "פירותי",
        creamy: "קרמי",
        vanilla: "וניל",
        mint: "מנטה",
        eucalyptus: "אקליפטוס",
        citrus: "הדרי",
        pine: "אורן",
        berries: "פירות יער",
        grape: "ענבים",
        mango: "מנגו",
        lychee: "ליצ'י",
        guava: "גויאבה",
        passionFruit: "פסיפלורה",
        earthy: "אדמתי",
        woody: "עציי",
        spicy: "מתובל",
        chemical: "כימי",
        metal: "מתכתי",
        fermentation: "תסיסה",
        other: "אחר",
      },
      flavorMatchesAroma: {
        yes: "כן",
        partially: "חלקית",
        no: "לא",
      },
      flavorIntensity: {
        weak: "חלש",
        medium: "בינוני",
        strong: "חזק",
      },
      flavorDynamics: {
        staysToEnd: "נשאר עד הסוף",
        fadesMiddle: "נחלש באמצע",
        onlyBeginning: "רק בהתחלה",
      },
      aftertaste: {
        sweet: "מתוק",
        sour: "חמוץ",
        gassy: "גזי",
        earthy: "אדמתי",
        minty: "מנטולי",
        metallic: "מתכתי",
        other: "אחר",
      },
      throatFeel: {
        smooth: "חלק",
        normal: "רגיל",
        harsh: "מחוספס",
        burns: "שורף",
      },
      burn: {
        excellent: "מצוין",
        normal: "רגיל",
        bad: "גרוע",
      },
      ash: {
        white: "לבן",
        gray: "אפור",
        dark: "כהה",
      },
      tarOilyRing: {
        none: "אין",
        slight: "קל",
        strong: "חזק",
      },
      losesFlavor: {
        yes: "כן",
        no: "לא",
      },
      negativeSensations: {
        dries: "מייבש",
        stings: "שורף",
        cough: "שיעול",
        hardToDraw: "קשה לשאיפה",
        none: "אין",
      },
      effectType: {
        indica: "אינדיקה",
        sativa: "סטיבה",
        hybrid: "היברידי",
      },
      effectStrength: {
        weak: "חלש",
        medium: "בינוני",
        strong: "חזק",
      },
      direction: {
        up: "למעלה",
        neutral: "ניטרלי",
        down: "למטה",
        wavy: "גלי",
        slowOnset: "התחלה איטית",
        sharpStart: "התחלה חדה",
      },
      mentalEffects: {
        clarityFocus: "בהירות/פוקוס",
        improvesMood: "משפר מצב רוח",
        calmsThoughts: "מרגיע מחשבות",
        speedsThoughts: "מאיץ מחשבות",
        fog: "ערפל",
        creativity: "יצירתיות",
        talkative: "פטפטן",
        social: "חברתי",
        withdrawn: "סגור",
      },
      bodyEffects: {
        bodyRelaxation: "הרפיית גוף",
        heaviness: "כבדות",
        eyePressure: "לחץ בעיניים",
        softWarmth: "חום עדין",
        numbness: "נימול",
        tingling: "עקצוץ",
        bodyEnergy: "אנרגיית גוף",
      },
      functionalEffects: {
        painRelief: "הקלה בכאב",
        antiStress: "אנטי-סטרס",
        antiAnxiety: "אנטי-חרדה",
        appetiteIncrease: "הגברת תיאבון",
        helpsSleep: "מסייע לשינה",
        suitableForWork: "מתאים לעבודה",
        suitableForRest: "מתאים למנוחה",
      },
      duration: {
        short: "קצר",
        medium: "בינוני",
        long: "ארוך",
      },
      timeOfUse: {
        day: "יום",
        evening: "ערב",
        night: "לילה",
      },
      recognizability: {
        yes: "כן",
        ratherYes: "כנראה כן",
        ratherNo: "כנראה לא",
        no: "לא",
      },
      whoIsItFor: {
        beginners: "מתחילים",
        experienced: "מנוסים",
        medicalUsers: "משתמשים רפואיים",
        dayUse: "לשימוש ביום",
        eveningSleep: "ערב/שינה",
        social: "חברתי",
        solo: "לבד",
      },
      associationPositioning: {
        commercialHit: "להיט מסחרי",
        boutique: "בוטיק (נישה)",
        exotic: "אקזוטי",
        connoisseurs: "לאניני טעם",
        rawPotential: "יש פוטנציאל אך לא מגובש",
      },
      strengths: {
        visual: "חזות",
        smell: "ריח",
        taste: "טעם",
        effect: "השפעה",
        uniqueness: "ייחודיות",
        commercialPotential: "פוטנציאל מסחרי",
      },
      preserve: {
        genetics: "גנטיקה",
        terpenes: "טרפנים",
        structure: "מבנה",
        effect: "השפעה",
        overallFeeling: "תחושה כללית",
      },
      downsides: {
        weakTaste: "טעם חלש",
        effectFadesQuickly: "האפקט נחלש מהר",
        heavyOnset: "התחלה כבדה",
        irritatesThroat: "מגרה את הגרון",
        tooSharp: "חד מדי",
        unclearEffect: "אפקט לא ברור",
        noClearCharacter: "אין אופי ברור",
        other: "אחר",
      },
      commercialPotential: {
        low: "נמוך",
        medium: "בינוני",
        high: "גבוה",
      },
      wouldBuyAgain: {
        yesDefinitely: "כן, בהחלט",
        maybe: "אולי",
        no: "לא",
      },
    },
  },
  ua: {
    title: "Професійні відгуки",
    common: {
      loading: "Завантаження...",
      save: "Зберегти",
      delete: "Видалити",
      noData: "Немає даних",
      login: "Увійти",
    },
    sections: {
      filters: "Фільтри",
      strainSelection: "Вибір сорту",
      tastingMetadata: "Дані дегустації",
      visual: "Візуал",
      aroma: "Аромат",
      flavor: "Смак",
      smokeQuality: "Якість диму",
      effect: "Ефект",
      scales: "Шкали та впізнаваність",
      points: "Акценти — що підсилити і що зберегти",
      final: "Підсумок",
      savedReviews: "Збережені відгуки",
    },
    fields: {
      reviewName: "Назва відгуку",
      strain: "Сорт",
      customStrainName: "Власна назва сорту",
      customStrainCode: "Власний код сорту",
      strainSelectionRequired: "Вибір сорту",
      tastingDate: "Дата дегустації",
      authorNameOptional: "Автор (необов'язково)",
      consumptionMethod: "Спосіб споживання",
      dosage: "Дозування / кількість затяжок",
      context: "Контекст",
      visualScore: "Оцінка візуалу",
      budShape: "Форма шишок",
      densityOnSqueeze: "Щільність при стисканні",
      trichomesCharacter: "Характер трихом",
      trichomeCoverage: "Покриття трихомами",
      colorPalette: "Кольорова палітра",
      firstVisualImpression: "Перше візуальне враження",
      aromaIntensity: "Інтенсивність аромату",
      aromaOpening: "Розкриття аромату",
      aromaProfile: "Профіль аромату",
      flavorMatchesAroma: "Чи відповідає смак аромату",
      flavorIntensity: "Інтенсивність смаку",
      flavorDynamics: "Динаміка смаку",
      aftertaste: "Післясмак",
      throatFeel: "Відчуття в горлі",
      burn: "Горіння",
      ash: "Попіл",
      tarOilyRing: "Смола / масляне кільце",
      losesFlavor: "Втрачає смак під час куріння",
      negativeSensations: "Негативні відчуття під час куріння",
      effectType: "Тип ефекту",
      effectStrength: "Сила ефекту",
      direction: "Напрям",
      mentalEffects: "Ментальні ефекти",
      bodyEffects: "Тілесні ефекти",
      functionalEffects: "Функціональні ефекти",
      duration: "Тривалість",
      timeOfUse: "Час використання",
      recognizability: "Впізнаваність (наосліп)",
      whoIsItFor: "Для кого?",
      associationPositioning: "Асоціація/позиціонування",
      strengths: "Сильні сторони",
      preserve: "Зберегти",
      downsides: "Недоліки/відхилення",
      commercialPotential: "Комерційний потенціал",
      wouldBuyAgain: "Купили б знову?",
      summaryStrongest: "Короткий підсумок: що найсильніше?",
      summaryImprove: "Короткий підсумок: що покращити в наступній партії?",
      summaryScores: {
        visual: "Візуал",
        aroma: "Аромат",
        flavor: "Смак",
        effect: "Ефект",
        uniqueness: "Унікальність",
      },
      comment: "Коментар",
    },
    placeholders: {
      selectStrain: "Оберіть сорт",
      otherText: "Інше (текст)",
      allStrains: "Усі сорти",
      effectStrength: "Сила ефекту",
      commercialPotential: "Комерційний потенціал",
      recognizability: "Впізнаваність",
    },
    actions: {
      applyFilters: "Застосувати фільтри",
      clearFilters: "Скинути фільтри",
      downloadPublic: "Завантажити (публічний)",
      downloadInternal: "Завантажити (внутрішній)",
      downloadExtended: "Завантажити (розширений)",
      duplicate: "Дублювати",
      edit: "Редагувати",
    },
    table: {
      strain: "Сорт",
      date: "Дата",
      author: "Автор",
      effectStrength: "Сила ефекту",
      commercialPotential: "Комерційний потенціал",
      recognizability: "Впізнаваність",
    },
    messages: {
      missingFieldsTitle: "Відсутні обов'язкові поля",
      loadFailed: "Не вдалося завантажити відгуки",
      saveFailed: "Не вдалося зберегти відгук",
      saved: "Збережено",
      downloadFailed: "Не вдалося завантажити",
      confirmDelete: "Видалити відгук?",
    },
    options: {
      scale: {
        "1": "1",
        "2": "2",
        "3": "3",
        "4": "4",
        "5": "5",
      },
      consumptionMethod: {
        joint: "Джойнт",
        bong: "Бонг",
        pipe: "Трубка",
        vaporizer: "Вапорайзер",
        other: "Інше",
      },
      dosage: {
        low: "Низька",
        medium: "Середня",
        high: "Висока",
      },
      context: {
        alone: "Наодинці",
        withCompany: "У компанії",
        beforeSleep: "Перед сном",
        beforeWork: "Перед роботою",
        onWeekends: "На вихідних",
      },
      budShape: {
        spherical: "Куляста",
        conical: "Конічна",
        arrow: "Шип / стріла",
        clumpy: "Грудкувата",
        wild: "Нерівна / дика",
        commercial: "Комерційна (рівна, охайна)",
      },
      densityOnSqueeze: {
        stone: "Камінь",
        veryDense: "Дуже щільна",
        medium: "Середня",
        airy: "Повітряна",
        fluffy: "Пухка",
      },
      trichomesCharacter: {
        dusty: "Пилова (крихка)",
        greasy: "Жирна (липка)",
        glassy: "Скляна (блискуча)",
        matte: "Матова",
        speckled: "Плямиста",
        even: "Рівномірна",
      },
      trichomeCoverage: {
        low: "Низьке",
        medium: "Середнє",
        high: "Високе",
      },
      colorPalette: {
        lightGreen: "Світло-зелений",
        darkGreen: "Темно-зелений",
        purple: "Фіолетовий",
        almostBlack: "Майже чорний",
        silver: "Сріблястий",
        orangePistils: "Помаранчеві пестики",
        redPistils: "Червоні пестики",
        yellowPistils: "Жовті пестики",
      },
      firstVisualImpression: {
        wow: "Вау",
        veryInteresting: "Дуже цікаво",
        normal: "Нормально",
        nothingSpecial: "Нічого особливого",
      },
      aromaIntensity: {
        weak: "Слабкий",
        medium: "Середній",
        strong: "Сильний",
      },
      aromaOpening: {
        noChange: "Без змін",
        increasesWhenBroken: "Посилюється при розламі",
        increasesWhenGrinded: "Посилюється при подрібненні",
      },
      aromaProfile: {
        diesel: "Дизель",
        skunk: "Скунс",
        rubber: "Гума",
        glue: "Клей",
        candy: "Цукерки",
        fruity: "Фруктовий",
        creamy: "Вершковий",
        vanilla: "Ваніль",
        mint: "М'ята",
        eucalyptus: "Евкаліпт",
        citrus: "Цитрус",
        pine: "Сосна",
        berries: "Ягоди",
        grape: "Виноград",
        mango: "Манго",
        lychee: "Лічі",
        guava: "Гуава",
        passionFruit: "Маракуйя",
        earthy: "Землистий",
        woody: "Деревний",
        spicy: "Пряний",
        chemical: "Хімічний",
        metal: "Металевий",
        fermentation: "Ферментація",
        other: "Інше",
      },
      flavorMatchesAroma: {
        yes: "Так",
        partially: "Частково",
        no: "Ні",
      },
      flavorIntensity: {
        weak: "Слабка",
        medium: "Середня",
        strong: "Сильна",
      },
      flavorDynamics: {
        staysToEnd: "Тримається до кінця",
        fadesMiddle: "Зникає всередині",
        onlyBeginning: "Лише на початку",
      },
      aftertaste: {
        sweet: "Солодкий",
        sour: "Кислий",
        gassy: "Газовий",
        earthy: "Землистий",
        minty: "М'ятний",
        metallic: "Металевий",
        other: "Інше",
      },
      throatFeel: {
        smooth: "М'яко",
        normal: "Нормально",
        harsh: "Жорстко",
        burns: "Пече",
      },
      burn: {
        excellent: "Відмінно",
        normal: "Нормально",
        bad: "Погано",
      },
      ash: {
        white: "Білий",
        gray: "Сірий",
        dark: "Темний",
      },
      tarOilyRing: {
        none: "Немає",
        slight: "Слабке",
        strong: "Сильне",
      },
      losesFlavor: {
        yes: "Так",
        no: "Ні",
      },
      negativeSensations: {
        dries: "Сушить",
        stings: "Щипає",
        cough: "Кашель",
        hardToDraw: "Важко тягнути",
        none: "Немає",
      },
      effectType: {
        indica: "Індика",
        sativa: "Сатива",
        hybrid: "Гібрид",
      },
      effectStrength: {
        weak: "Слабкий",
        medium: "Середній",
        strong: "Сильний",
      },
      direction: {
        up: "Вгору",
        neutral: "Нейтрально",
        down: "Вниз",
        wavy: "Хвилями",
        slowOnset: "Повільний початок",
        sharpStart: "Різкий старт",
      },
      mentalEffects: {
        clarityFocus: "Ясність/фокус",
        improvesMood: "Покращує настрій",
        calmsThoughts: "Заспокоює думки",
        speedsThoughts: "Прискорює думки",
        fog: "Туман",
        creativity: "Творчість",
        talkative: "Балакучість",
        social: "Соціальність",
        withdrawn: "Замкнутість",
      },
      bodyEffects: {
        bodyRelaxation: "Розслаблення тіла",
        heaviness: "Важкість",
        eyePressure: "Тиск в очах",
        softWarmth: "М'яке тепло",
        numbness: "Оніміння",
        tingling: "Поколювання",
        bodyEnergy: "Енергія тіла",
      },
      functionalEffects: {
        painRelief: "Знеболення",
        antiStress: "Антистрес",
        antiAnxiety: "Проти тривоги",
        appetiteIncrease: "Підвищення апетиту",
        helpsSleep: "Допомагає заснути",
        suitableForWork: "Підходить для роботи",
        suitableForRest: "Підходить для відпочинку",
      },
      duration: {
        short: "Коротка",
        medium: "Середня",
        long: "Довга",
      },
      timeOfUse: {
        day: "День",
        evening: "Вечір",
        night: "Ніч",
      },
      recognizability: {
        yes: "Так",
        ratherYes: "Скоріше так",
        ratherNo: "Скоріше ні",
        no: "Ні",
      },
      whoIsItFor: {
        beginners: "Початківці",
        experienced: "Досвідчені",
        medicalUsers: "Медичні користувачі",
        dayUse: "Денне використання",
        eveningSleep: "Вечір/сон",
        social: "Соціальне",
        solo: "Наодинці",
      },
      associationPositioning: {
        commercialHit: "Комерційний хіт",
        boutique: "Бутік (ніша)",
        exotic: "Екзотика",
        connoisseurs: "Для поціновувачів",
        rawPotential: "Є потенціал, але сирувато",
      },
      strengths: {
        visual: "Візуал",
        smell: "Запах",
        taste: "Смак",
        effect: "Ефект",
        uniqueness: "Унікальність",
        commercialPotential: "Комерційний потенціал",
      },
      preserve: {
        genetics: "Генетика",
        terpenes: "Терпени",
        structure: "Структура",
        effect: "Ефект",
        overallFeeling: "Загальне відчуття",
      },
      downsides: {
        weakTaste: "Слабкий смак",
        effectFadesQuickly: "Ефект швидко зникає",
        heavyOnset: "Важкий початок",
        irritatesThroat: "Дратує горло",
        tooSharp: "Надто різкий",
        unclearEffect: "Незрозумілий ефект",
        noClearCharacter: "Немає чіткого характеру",
        other: "Інше",
      },
      commercialPotential: {
        low: "Низький",
        medium: "Середній",
        high: "Високий",
      },
      wouldBuyAgain: {
        yesDefinitely: "Так, точно",
        maybe: "Можливо",
        no: "Ні",
      },
    },
  },
};
